import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormularyDrugSearchComponent } from './formulary-drug-search/formulary-drug-search.component';
import { PdlViewerDrugSearchDataAccessModule } from '@cigna/pdl-viewer/drug-search/data-access';
import { FormsModule } from '@angular/forms';
import { UiPopoverModule } from '@cigna/shared/angular/popover-ui';
import { UiModalModule } from '@cigna/shared/angular/modal-ui';
import { UiIconModule } from '@cigna/shared/angular/icon-ui';
import { UiInputModule } from '@cigna/shared/angular/input-ui';
import { UiButtonModule } from '@cigna/shared/angular/button-ui';
import { PdlViewerDrugSearchUiModule } from '@cigna/pdl-viewer/drug-search/ui';
import { PdlViewerSharedUtilModule } from '@cigna/pdl-viewer/shared/util';
import { UiProgressModule } from '@cigna/shared/angular/progress-ui';
import { TranslateModule } from '@ngx-translate/core';

const DECLARATIONS = [FormularyDrugSearchComponent];
@NgModule({
  imports: [
    CommonModule,
    PdlViewerDrugSearchDataAccessModule,
    FormsModule,
    UiPopoverModule,
    UiIconModule,
    UiButtonModule,
    UiModalModule,
    UiProgressModule,
    UiInputModule,
    PdlViewerDrugSearchUiModule,
    PdlViewerSharedUtilModule,
    TranslateModule,
  ],
  declarations: [...DECLARATIONS],
  exports: [...DECLARATIONS],
})
export class PdlViewerDrugSearchFeatureModule {}
